import request from '@/utils/request'


// 查询打赏列表
export function listReward(query) {
  return request({
    url: '/reward/reward/list',
    method: 'get',
    params: query
  })
}

// 查询打赏分页
export function pageReward(query) {
  return request({
    url: '/reward/reward/page',
    method: 'get',
    params: query
  })
}

// 查询打赏详细
export function getReward(data) {
  return request({
    url: '/reward/reward/detail',
    method: 'get',
    params: data
  })
}

// 新增打赏
export function addReward(data) {
  return request({
    url: '/reward/reward/add',
    method: 'post',
    data: data
  })
}

// 修改打赏
export function updateReward(data) {
  return request({
    url: '/reward/reward/edit',
    method: 'post',
    data: data
  })
}

// 删除打赏
export function delReward(data) {
  return request({
    url: '/reward/reward/delete',
    method: 'post',
    data: data
  })
}
